import { ApolloError } from '@apollo/client'

type Options = {
  defaultMessage: string
}

const defaultMessage = 'Something went wrong. Please try again.'

export function extractErrorMessage(error: unknown, options: Options = { defaultMessage }) {
  if (error instanceof ApolloError) {
    const apolloErrorMessage = error.graphQLErrors?.[0]?.message
    return apolloErrorMessage || options.defaultMessage
  }

  if (error instanceof Error) {
    return error.message
  }

  return options.defaultMessage
}
